const baseUrl = {
  api: "https://api.play.tradezyapp.com",
  slack: "https://slack.play.tradezyapp.com",
  notification: "https://notifications.play.tradezyapp.com",
  billing: "https://billing.play.tradezyapp.com",
  interactiveBroker: "https://ibkr.play.tradezyapp.com",
};

export default baseUrl;
